import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type PropsType = {
	className?: string;
	children: any;
};

export const FilterContainer = ({ className, children }: PropsType) => {
	return (
		<div className={clsx(styles.filterContainer, className)}>
			{children}
		</div>
	);
};
